/** D115: Google coordinates are working state for strictly less than 29 days. */
export const GOOGLE_PLACEHOLDER = 'Google details unavailable';
export const GOOGLE_EXPIRED = 'Google location expired';
export const COORDINATE_TTL_MS = 29 * 86_400_000;
export const coordinatesFresh = (clock: string | null | undefined, now = new Date()): boolean => {
  if (!clock) return false;
  const at = Date.parse(clock);
  return Number.isFinite(at) && at <= now.getTime() && at > now.getTime() - COORDINATE_TTL_MS;
};
